export default __webpack_public_path__ + "dd59daedf2234981ea52e6da02bc24eb.png";